import { InjectionToken } from "@angular/core";
import { AuthFacade } from "./auth.facade";

export const AUTH_SERVICE_TOKEN = new InjectionToken<AuthFacade>(
  'AUTH_SERVICE_TOKEN'
);
